import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faTimes,
  faCaretDown,
  faMapSigns,
  faMapMarked,
  faMapMarkedAlt,
  faBars,
} from '@fortawesome/free-solid-svg-icons';
import {
  faTelegram,
  faTelegramPlane,
  faMeetup,
  faGooglePlus,
  faInstagram,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faTimes);
library.add(faCaretDown);
library.add(faMapSigns);
library.add(faMapMarked);
library.add(faMapMarkedAlt);
library.add(faBars);

library.add(faTelegram);
library.add(faTelegramPlane);
library.add(faMeetup);
library.add(faGooglePlus);
library.add(faInstagram);
library.add(faFacebook);

Vue.component('font-awesome-icon', FontAwesomeIcon);
